import './route.scss';

import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { DisplayMessage } from '@core/app/scripts/services/display-message';
import { CashierSession } from '@shared/app/scripts/services/cashier-session';
import { Ga } from '@core/app/scripts/services/ga';
import { Route } from '@pos/app/scripts/services/route';

/*
 * Component responsible for /route route.
 */
angular
  .module('posApp')
  .directive(
    'route',
    (
      $rootScope: ng.IRootScopeService,
      cashierSession: CashierSession,
      displayMessage: DisplayMessage,
      ga: Ga,
      navigateTo: NavigateTo,
      pinProvider,
      route: Route,
      translate,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./route.html').default,

      link: function ($scope, element, attrs) {
        const $translate = translate;

        let pinInProgress = false;

        $scope.route = route;

        function parseRoute(hash) {
          const paramMatch = hash.match(/\/([^/]*)/),
            refMatch = hash.match(/\/([^/]*)/g);

          // in #lorem-ipsum/123&ref=sin-dolor , 123 is param, sin-dolor is ref
          const page = hash.match(/[^\//]*/)[0];

          let param, ref;

          if (paramMatch && paramMatch[1]) {
            param = paramMatch[1];
          }

          if (refMatch && refMatch[1]) {
            ref = decodeURIComponent(refMatch[1].substr(1));
          }

          route.navigateTo(page, param, ref);
        }

        parseRoute('main');

        element.addClass('no-print');

        // Hack! To be replaced by custom operator rx operator
        const wrapInSafeApply =
          require('../../../../../global/wrap-in-safe-apply')($scope);

        pinProvider.inProgress$.subscribe(
          wrapInSafeApply((status) => {
            pinInProgress = status;
          }),
        );

        $rootScope.$on('navigateTo', (event, data) => {
          const lastRoute = $scope.route.page;

          /*
           * Google Analytics support
           */
          ga.pageview();

          if (lastRoute === 'checkout' && pinInProgress) {
            displayMessage.message({
              message: $translate.instant('BlockPINRedirect'),
              time: 6000,
            });

            navigateTo('pos.route#checkout');
            return;
          }

          parseRoute(data);

          if ($scope.route.page !== 'main' && !cashierSession.isActive) {
            navigateTo('pos.route#main');
          }
        });
      },
    }),
  );
